module.exports = __webpack_public_path__ + "static/media/arayaa.1ad91405.jpeg";